import { BaseError } from './base';

export class MissingRedirectStorageStateError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'missing_redirect_storage_state_error',
      docsUrl: null,
      name: 'MissingRedirectStorageStateError',
      shortMessage:
        'The social redirect data was not found in local storage. Try connecting again.',
    });
  }
}
